module.exports = __webpack_public_path__ + "static/img/logo.8d18b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/logo.png
// module id = Zd90
// module chunks = 29